import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization";
import { cn } from "@faire/web/tools/cn";
import React from "react";

import { SVGIconV2 } from "./SVGIconV2";
import { SVGIconComponentV2, SVGIconPropsV2 } from "./types";

export function createSVGIconV2(
  path: React.ReactNode,
  displayName: string,
  defaultProps?:
    | ((strictLocalize: StrictLocalizeFunction) => SVGIconPropsV2)
    | SVGIconPropsV2
): SVGIconComponentV2 {
  const Component = React.memo(
    ({ ...props }: SVGIconPropsV2 & React.RefAttributes<SVGElement>) => {
      const { strictLocalize } = useStrictLocalization();
      const unwrappedDefaultProps =
        typeof defaultProps === "function"
          ? defaultProps?.(strictLocalize)
          : defaultProps;

      const { className: defaultClass, titleAccess } =
        unwrappedDefaultProps ?? {};
      const { className: explicitClass } = props ?? {};

      return (
        <SVGIconV2
          titleAccess={titleAccess}
          {...unwrappedDefaultProps}
          {...props}
          className={cn(defaultClass, explicitClass)}
        >
          {path}
        </SVGIconV2>
      );
    }
  );

  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Icon`;
  }

  return Component;
}
